class StickyApplyButton {
    constructor() {
        this.DOM = {
            button: document.querySelector('.sticky-apply-button'),
            pageIntro: document.querySelector('.page-intro-wrapper'),
            contactForm: document.getElementById('vacancy-contact-form')
        };

        if (!this.DOM.button || !this.DOM.pageIntro) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        this.pastIntro = false;
        this.contactFormVisible = false;

        this.setTriggers();
    }

    setTriggers() {
        ScrollTrigger.create({
            // markers: true,
            trigger: this.DOM.pageIntro,
            start: 'bottom top',
            onEnter: () => {
                this.pastIntro = true;
                this.updateVisibility();
            },
            onLeaveBack: () => {
                this.pastIntro = false;
                this.updateVisibility();
            }
        });

        if (this.DOM.contactForm) {
            ScrollTrigger.create({
                // markers: true,
                trigger: this.DOM.contactForm,
                start: 'top bottom',
                end: 'bottom top',
                onEnter: () => {
                    this.contactFormVisible = true;
                    this.updateVisibility();
                },
                onLeave: () => {
                    this.contactFormVisible = false;
                    this.updateVisibility();
                },
                onEnterBack: () => {
                    this.contactFormVisible = true;
                    this.updateVisibility();
                },
                onLeaveBack: () => {
                    this.contactFormVisible = false;
                    this.updateVisibility();
                }
            });
        }
    }

    updateVisibility() {
        this.DOM.button.classList.toggle('visible', this.pastIntro && !this.contactFormVisible);
    }
}
new StickyApplyButton();
